import React from 'react';
import { Button, Stack, Text } from '@welbe/design-system';
import { useModalHasActiveUser } from './useModalHasActiveUser.hooks';

type ModalHasActiveUserProps = {
	activeSession: boolean | null;
	handleClose: () => void;
	handleLogout: () => void;
};

export const ModalHasActiveUser = ({
	activeSession,
	handleClose,
	handleLogout,
}: ModalHasActiveUserProps) => {
	const { modalMessage } = useModalHasActiveUser({
		handleLogout,
		activeSession,
	});

	return (
		<Stack width="100%" gap="1rem">
			<Text>{modalMessage.title}</Text>
			<p>{modalMessage.message} </p>
			<Button onClick={handleClose}>{modalMessage.button}</Button>
		</Stack>
	);
};
